import { Link, useLocation } from "wouter";
import { useThemeStore } from "@/lib/themeStore";
import { Moon, Sun } from "lucide-react";

export function Header() {
  const [location] = useLocation();
  const { dark, toggle } = useThemeStore();

  return (
    <header className="bg-white dark:bg-gray-900 shadow-sm border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-lenovo-red flex items-center justify-center rounded">
              <span className="text-white font-bold text-sm">L</span>
            </div>
            <div>
              <h1 className="text-xl font-semibold text-gray-900 dark:text-white">LLM GPU Sizing Calculator</h1>
              <p className="text-sm text-lenovo-gray dark:text-gray-400">Calculate optimal GPU requirements for your LLM workloads</p>
            </div>
          </div>

          <nav className="flex items-center gap-1">
            <Link href="/">
              <a className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                location === "/"
                  ? "bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white"
                  : "text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-800"
              }`}>
                Calculator
              </a>
            </Link>
            <Link href="/cpu-sizing">
              <a className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                location === "/cpu-sizing"
                  ? "bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white"
                  : "text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-800"
              }`}>
                CPU Sizing
              </a>
            </Link>

            {/* Dark mode toggle */}
            <button
              onClick={toggle}
              className="ml-2 p-2 rounded-md text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
            >
              {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
}